import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}><path d="M22 12c0 5.524-4.477 10-10 10S2 17.524 2 12C2 6.478 6.477 2 12 2s10 4.478 10 10" opacity=".4" /><path d="M15.573 15.814a.76.76 0 01-.383-.105l-3.926-2.342a.75.75 0 01-.365-.645V7.675a.75.75 0 011.5 0v4.621l3.56 2.123a.752.752 0 01-.386 1.395" /></svg>;